import React from "react";
import { Navigate } from "react-router-dom";
import AuthService from "../services/AuthService";

export default function PrivateRoute({ children }) {
  const currentUser = AuthService.getCurrentUser();
  return currentUser ? children : <Navigate to="/" />;
}
